import * as styles from './index.css';
import { useAnalytics, useEventScope } from '@blueshift-ui/analytics';
import Alert from '@blueshift-ui/feedback/dist/components/alert';
import AlertTitle from '@mui/material/AlertTitle';
import Collapse from '@mui/material/Collapse';
import EVENT_NAMES from '../../../../../constants/generated/event-names';
import { Heart as HeartIcon } from '@phosphor-icons/react';
import { useState } from 'react';
import useTranslation from '@blueshift-ui/i18n/dist/hooks/use-translation';

function MembershipUnchangedBanner() {
  const analytics = useAnalytics();
  const eventScope = useEventScope();
  const { loading, translate } = useTranslation('membership.unchanged.banner');

  const [showAlert, setShowAlert] = useState(true);

  function handleClose() {
    setShowAlert(false);

    analytics.track(EVENT_NAMES.elementClicked, {
      element_id: 'close_membership_unchanged_banner_button',
      element_text: 'Close',
      element_type: 'button',
      page_path: window.location.pathname,
      page_section: eventScope?.pageSection,
    });
  }

  if (loading) {
    return null;
  }

  return (
    <Collapse in={showAlert}>
      <Alert
        className={styles.alert}
        icon={<HeartIcon weight="duotone" />}
        onClose={handleClose}
        severity="info"
      >
        <AlertTitle>{translate('title')}</AlertTitle>
        {translate('content')}
      </Alert>
    </Collapse>
  );
}

export default MembershipUnchangedBanner;
